/**
 * the enum for areas
 */
export const Regions = {
    North: "צפון",
    South: "דרום",
    dan: "גוש דן",
    Jerusalem:"ירושלים והסביבה",
    Shomron:"יהודה ושומרון"
}